import request from '@/utils/request'

// 查询手环工作流任务明细列表
export function listWristbandWorkflow(query) {
  return request({
    url: '/system/wristband-workflow/list',
    method: 'get',
    params: query,
  })
}

// 查询手环工作流任务明细分页
export function pageWristbandWorkflow(query) {
  return request({
    url: '/system/wristband-workflow/page',
    method: 'get',
    params: query,
  })
}

// 查询手环工作流任务明细详细
export function getWristbandWorkflow(data) {
  return request({
    url: '/system/wristband-workflow/detail',
    method: 'get',
    params: data,
  })
}

// 新增手环工作流任务明细
export function addWristbandWorkflow(data) {
  return request({
    url: '/system/wristband-workflow/add',
    method: 'post',
    data: data,
  })
}

// 修改手环工作流任务明细
export function updateWristbandWorkflow(data) {
  return request({
    url: '/system/wristband-workflow/edit',
    method: 'post',
    data: data,
  })
}

// 删除手环工作流任务明细
export function delWristbandWorkflow(data) {
  return request({
    url: '/system/wristband-workflow/delete',
    method: 'post',
    data: data,
  })
}

// 导入工作流明细数据
export function importWristbandWorkflowData(data) {
  return request({
    url: '/system/wristband-workflow/importData',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

// 批量导入手环工作流数据
export function importWristbandWorkflowDataBatch(data) {
  return request({
    url: '/system/wristband-workflow/importDataBatch',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
